import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveTaxonomy } from "../../../redux/slice/taxonomy-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

interface DiscoverProps {
  page?: string;
}

const Discover = (props: DiscoverProps) => {
  const { page } = props;
  const { data } = useSelector((state: RootState) => state.taxonomyList);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveTaxonomy());
  }, [dispatch]);

  return (
    <>
      {page !== undefined && page !== null && page === "profile" && (
        <>
          <p></p>
          <h3>Discover more of what matters to you</h3>
          <p></p>
          <div className="sectors">
            {data.map((item, index) => {
              var taxonomyId = "/search?taxonomy=" + item.taxonomyId;
              return (
                <a href={taxonomyId} key={index} className="btn btn-plain">
                  {item.categoryName}
                </a>
              );
            })}
          </div>
        </>
      )}
      {(page === undefined || page === null) && (
        <div className="container discover">
          <div className="col-md-12 sectors text-center">
            <h2>Discover more of what matters to you</h2>
            <br />
            {data.map((item, index) => {
              var taxonomyId = "/search?taxonomy=" + item.taxonomyId;
              return (
                <a href={taxonomyId} key={index} className="btn btn-plain">
                  {item.categoryName}
                </a>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Discover;
